const NS = 'RegistrationPage';
const CLS = 'registrationPage';

import { scrollTo } from 'scroll-js';
import { fullScreenLoaderService } from '../../../../../src/global/js/wlc/fullScreenLoaderService';
import { messages_en } from '../../../../../src/global/js/wlc/Custom_Validations/custom_validation_en';
import { messages_de } from '../../../../../src/global/js/wlc/Custom_Validations/custom_validation_de';
import { messages_es } from '../../../../../src/global/js/wlc/Custom_Validations/custom_validation_es';
import { messages_es_mx } from '../../../../../src/global/js/wlc/Custom_Validations/custom_validation_es-mx';
import { messages_fr } from '../../../../../src/global/js/wlc/Custom_Validations/custom_validation_fr';
import { messages_it } from '../../../../../src/global/js/wlc/Custom_Validations/custom_validation_it';
import { messages_ja } from '../../../../../src/global/js/wlc/Custom_Validations/custom_validation_ja';
import { messages_ko } from '../../../../../src/global/js/wlc/Custom_Validations/custom_validation_ko';
import { messages_vi } from '../../../../../src/global/js/wlc/Custom_Validations/custom_validation_vi';
import { messages_zh } from '../../../../../src/global/js/wlc/Custom_Validations/custom_validation_zh';
import { messages_zh_HK } from '../../../../../src/global/js/wlc/Custom_Validations/custom_validation_zh-HK';
import { messages } from '../../../../../src/global/js/wlc/Custom_Validations/custom_validation';


export class RegistrationPage {
	constructor(element) {
		this.element = element;
		this.$element = $(this.element);
		this.$tplScroller = $('.tpl-scroller');
		this.countryAPI = this.$element.data('countryApi');
		this.registerAPI = this.$element.data('registerApi');
		this.languageCode = this.$element.data('lang');
		this.$errorsServerSide = this.$element.find('.error-messages--serverSide');
		this.countries = [];
		this.$form = $(`#${CLS}-form`);
		this.regexPassword = '^(?=.*[A-Z])(?=.*[-!@#$%^&*()_+])(?=.*[0-9]).{8,20}$';
		this.siteTypeId = window['IDSConfig'] && window['IDSConfig'].Site && window['IDSConfig'].Site.API && window['IDSConfig'].Site.API.siteTypeId ? window['IDSConfig'].Site.API.siteTypeId : window['fallbackSiteID'];
		this.$formValidate;
		this.$role = this.$form.find('[name="Role"]');
		this.formTypes = {
			facilitator: 'facilitator',
			learner: 'learner'
		};
		this.fullScreenLoaderService = fullScreenLoaderService;

		this.$element.on('click', '[data-step-toggler]', (event) => {
			let stepTargetValue = $(event.currentTarget).data('stepTarget');
			this.$role.val('');

			if(stepTargetValue === 'form') {
				this.formType = $(event.currentTarget).data('formType');

				this.loadEducationLevel();
				this.loadOverMinimumAge();
				this.loadFacilitatorDocument();
				this.selectEvents();
				this.resetForm();
				this.setRoleValue();
			}

			this.goToStep(stepTargetValue);
		});

		if (this.countryAPI) {
			this.loadCountries();
		}
		var customValidation;
		switch (this.languageCode)
		{
			case 'de':
				customValidation = messages_de();
				break;
			case 'en':
				customValidation = messages_en();
				break;
			case 'es':
				customValidation = messages_es();
				break;
			case 'es-MX':
				customValidation = messages_es_mx();
				break;
			case 'fr':
				customValidation = messages_fr();
				break;
			case 'it':
				customValidation = messages_it();
				break;
			case 'ja':
				customValidation = messages_ja();
				break;
			case 'ko':
				customValidation = messages_ko();
				break;
			case 'vi':
				customValidation = messages_vi();
				break;
			case 'zh':
				customValidation = messages_zh();
				break;
			case 'zh-HK':
				customValidation = messages_zh_HK();
				break;
			default:
				customValidation = messages_en();
				break;
		}
		this.messages = customValidation;
		this.buildForm();
	}

	loadCountries() {
		$.ajax({
			type: 'GET',
			url: this.countryAPI,
			headers: {
				'X-IDS-SiteTypeId': this.siteTypeId
			},
			success: (data) => {
				this.countries = data;

				let $countrySelect = this.$element.find('select.country');
				$countrySelect.append(() => {
					let markup = '';
					this.countries.forEach((country) => {
						markup += `<option value="${country.Name}">${country.Name}</option>`;
					});
					return markup;
				});

				setTimeout(() => {
					$countrySelect.selectpicker('refresh');
					$countrySelect.selectpicker('render');
					this.resetForm(); // When countries is changed it sets it ot is-valid, reset said form to prevent this
				}, 100);
			},
			error: () => {
				console.error(`${NS}::Error`, 'Could not load the list of countries');
			}
		});
	}

	loadEducationLevel() {
		let $educationLevelFormGroup = this.$element.find(`.form-group--educationLevel`);

		if(this.formType === this.formTypes.facilitator) {
			$educationLevelFormGroup.html(
				`<label for="EducationLevelFacilitator">I am currently teaching…</label>
				<select class="form-control slctpckr educationLevel" name="EducationLevel" id="EducationLevelFacilitator" data-style="primary" title="Select what you’re teaching">
					<option value="" class="d-none" data-key=""></option>
					<option value="Facilitator - Primary" data-key="Primary">Primary</option>
					<option value="Facilitator - Secondary" data-key="Secondary">Secondary</option>
					<option value="Facilitator - Tertiary" data-key="Tertiary">Tertiary</option>
					<option value="Facilitator - Other" data-key="Other">Other</option>
				</select>`);
		}
		else if(this.formType === this.formTypes.learner) {
			$educationLevelFormGroup.html(
				`<label for="EducationLevelLearner">I am currently…</label>
				<select class="form-control slctpckr educationLevel" name="EducationLevel" id="EducationLevelLearner" data-style="primary" title="Select Education Level">
					<option value="" class="d-none" data-key=""></option>
					<option value="Studying - Secondary" data-key="Secondary">Studying — Secondary</option>
					<option value="Studying - Tertiary" data-key="Tertiary">Studying — Tertiary</option>
					<option value="Employed" data-key="Employed">Employed</option>
					<option value="Studying - Other" data-key="Other">Other</option>
				</select>`);
		}

		let $educationLevelSelect = this.$element.find('select.educationLevel');

		setTimeout(() => {
			$educationLevelSelect.selectpicker('refresh');
			$educationLevelSelect.selectpicker('render');

			if(this.formType === this.formTypes.facilitator) {
				$('#educationLevelFacilitator').rules('add', {
					required: true,
					messages: {
						required: messages(this.languageCode,'educationLevelFacilitator')
					}
				});
				$('#educationLevelLearner').rules('remove');
			}
			else if(this.formType === this.formTypes.learner) {
				$('#educationLevelFacilitator').rules('remove');
				$('#educationLevelLearner').rules('add', {
					required: true,
					messages: {
						required: messages(this.languageCode, 'educationLevelLearner')
					}
				});
			}
		}, 100);
	}

	loadOverMinimumAge() {
		if(this.formType === this.formTypes.learner) {
			$('.custom-checkbox--overMinimumAge').show();
			this.$form.find('[name="OverMinimumAge"]').rules('add', {
				required: true,
				messages: {
					required: messages(this.languageCode, 'overMinimumAge')
				}
			});
		}
		else {
			$('.custom-checkbox--overMinimumAge').hide();
			this.$form.find('[name="OverMinimumAge"]').rules('remove');
		}
	}

	loadFacilitatorDocument() {
		if(this.formType === this.formTypes.facilitator) {
			$('.custom-checkbox--facilitatorDocument').show();
			this.$form.find('[name="FacilitatorDocument"]').rules('add', {
				required: true,
				messages: {
					required: messages(this.languageCode, 'facilitatorDocument')
				}
			});
		}
		else {
			$('.custom-checkbox--facilitatorDocument').hide();
			this.$form.find('[name="FacilitatorDocument"]').rules('remove');
		}
	}

	goToStep(stepTargetValue) {
		this.$element.find('[data-step]').not(`[data-step='${stepTargetValue}']`).fadeOut(0).removeClass('is-active');
		let $stepTarget = this.$element.find(`[data-step='${stepTargetValue}']`);

		if(stepTargetValue === 'form') {
			$stepTarget.slideDown(800).fadeIn(0).addClass('is-active');
			this.$element.addClass(`${CLS}--formDisplayed`);
		}
		else {
			$stepTarget.fadeIn(0).addClass('is-active');
			this.$element.removeClass(`${CLS}--formDisplayed`);
		}

		scrollTo(this.$tplScroller[0], { top: 0, duration: 0 }); // Just scroll to the top of the page without animation
	}

	scrollToElement(element, offset = 0) {
		return scrollTo(this.$tplScroller[0], { top: $(element).position().top + offset, duration: 500, easing: 'ease-in-out' });
	}

	selectEvents() {
		this.$element.find('select').on('change', (event) => {
			$(event.currentTarget).blur().focus();
		});

		let formGroupElements = {
			educationLevelOther: this.$element.find('.form-group--educationLevelOther'),
			institution: this.$element.find('.form-group--institution'),
			areaStudy: this.$element.find('.form-group--areaStudy'),
			areaStudyOther: this.$element.find('.form-group--areaStudyOther'),
			howDidYouHearOther: this.$element.find('.form-group--howDidYouHearOther'),
			company: this.$element.find('.form-group--company'),
			expectedGraduationYear: this.$element.find('.form-group--expectedGraduationYear')
		};

		formGroupElements.institution.hide();
		formGroupElements.areaStudy.hide();
		formGroupElements.areaStudyOther.hide();
		formGroupElements.howDidYouHearOther.hide();
		formGroupElements.company.hide();
		formGroupElements.expectedGraduationYear.hide();
		formGroupElements.educationLevelOther.hide();

		if(this.formType === this.formTypes.learner) {
			formGroupElements.institution.show();
		}
		if(this.formTypes === this.formTypes.facilitator) {
			formGroupElements.areaStudy.show();
		}

		// Deals with on change for education level
		this.$element.find('select.educationLevel').on('change', (event) => {
			let key = $(event.currentTarget.options[event.currentTarget.selectedIndex]).attr('data-key');

			if(this.formType === this.formTypes.facilitator) {
				if(key === 'Other') {
					formGroupElements.areaStudy.hide().find('[name="AreaStudy"]').selectpicker('val', '').selectpicker('refresh').removeClass('is-valid is-invalid');
					formGroupElements.areaStudyOther.hide().find('[name="AreaStudyOther"]').val('').removeClass('is-valid is-invalid');
					formGroupElements.institution.hide().find('[name="Institution"]').val('').removeClass('is-valid is-invalid');
					formGroupElements.educationLevelOther.show();
				}
				else {
					formGroupElements.areaStudy.show();
					formGroupElements.institution.show();
					formGroupElements.educationLevelOther.hide().find('[name="EducationLevelOther"]').val('').removeClass('is-valid is-invalid');
				}
			}
			else if(this.formType === this.formTypes.learner) {
				if(key === 'Other' || key === 'Employed') {
					formGroupElements.areaStudy.hide().find('[name="AreaStudy"]').selectpicker('val', '').selectpicker('refresh').removeClass('is-valid is-invalid');
					formGroupElements.areaStudyOther.hide().find('[name="AreaStudyOther"]').val('').removeClass('is-valid is-invalid');
					formGroupElements.expectedGraduationYear.hide().find('[name="Expected_Graduation_Year"]').selectpicker('val', '').selectpicker('refresh').removeClass('is-valid is-invalid');
					formGroupElements.institution.hide().val('').removeClass('is-valid is-invalid');
				}
				if(key === 'Secondary' || key === 'Tertiary') {
					formGroupElements.areaStudy.show();
					formGroupElements.expectedGraduationYear.show();
					formGroupElements.institution.show();
				}

				if(key === 'Other') {
					formGroupElements.educationLevelOther.show();
				}
				else {
					formGroupElements.educationLevelOther.hide().find('[name="EducationLevelOther"]').val('').removeClass('is-valid is-invalid');
				}

				if(key === 'Employed') {
					formGroupElements.company.show();
				}
				else {
					formGroupElements.company.hide().find('[name="EmployedCompany"]').val('').removeClass('is-valid is-invalid');
				}
			}
		});

		// Deals with change for area of study
		this.$element.find('select.areaStudy').on('change', (event) => {
			if($(event.currentTarget).val() === 'Other') {
				formGroupElements.areaStudyOther.show();
			}
			else {
				formGroupElements.areaStudyOther.hide().find('[name="AreaStudyOther"]').val('').removeClass('is-valid is-invalid');
			}
		});

		// Deals with select change for how did you hear
		this.$element.find('select.howDidYouHear').on('change', (event) => {
			if($(event.currentTarget).val() === 'Other') {
				formGroupElements.howDidYouHearOther.show();
			}
			else {
				formGroupElements.howDidYouHearOther.hide().find('[name="HowDidYouHear"]').val('').removeClass('is-valid is-invalid');
			}
		});
	}

	handleServerSideError(message) {
		this.$errorsServerSide.addClass('is-active').html(message);
	}

	resetForm() {
		this.$form.removeClass('is-submitted');
		this.$formValidate.resetForm();
	}

	setRoleValue() {
		this.$role.val(this.formType);
	}

	/**
	 * Implements the form and form validation using jQuery validation: https://jqueryvalidation.org/
	 */
	buildForm() {
		$.validator.addMethod('password', (value, _element) => {
			return new RegExp(this.regexPassword).test(value);
		}, `Please enter a password that contains 8–20 characters, at least one capital letter, one number, and one special character [- ! @ # $ % ^ & * ( ) _ +].`);

		this.$formValidate = this.$form.validate({
			submitHandler: (form, event) => {
				this.$errorsServerSide.removeClass('is-active').text('');
				$(event.currentTarget).addClass('is-submitted');
				event.preventDefault();

				var array = $(form).serializeArray()
				var formData = {};
				$.map(array, function (n, i) {
					formData[n['name']] = n['value'];
				});

				formData['languageCode'] = IDSConfig.CurrentLanguage;
				delete formData['__RequestVerificationToken'];
				delete formData['OverMinimumAge'];

				// Removes empty field values
				_.forOwn(formData, (value, key) => {
					if(_.isNil(value) || value.trim() === '') {
						delete formData[key];
					}
				});

				var json_text = JSON.stringify(formData);

				let request = new Request(this.registerAPI, {
					method: 'POST',
					body: json_text,
					headers: {
						'Content-Type': 'application/json'
					}
				});

				this.fullScreenLoaderService.create();

				// submit form data using fetch api
				fetch(request)
					.then((response) => response.json())
					.then((data) => {
						// check status
						if(data.Message === undefined && data.IsRegisteredUser === false) {
							this.goToStep('success');
							this.$form.trigger('registrationSuccess');
						}
						else if(data.IsRegisteredUser === true) {
							// successful call but no success status
							this.handleServerSideError(`<p>There is already an account associated with this email address. Please login below to gain access to your account. <a href="/login-page">Go to Login Page</a></p>`);
						}
						else {
							// successful call but no success status
							this.handleServerSideError(data.Message);
						}
						this.fullScreenLoaderService.destroy();
					})
					.catch((error) => {
						// errors (failed call)
						this.handleServerSideError(error.message);
						this.fullScreenLoaderService.destroy();
					});
			},
			invalidHandler: (event, validator) => {
				$(event.currentTarget).addClass('is-submitted');
				if(validator.errorList[0]) {
					let element = validator.errorList[0].element;
					// Caveat for custom-control (radio + checkbox) as the element itself is absolutely positioned.
					// Scroll to the parent element of it instead.
					if($(element).parent('.custom-control') && $(element).parent('.custom-control').length > 0) {
						this.scrollToElement($(element).parent('.custom-control')[0], -60);
					}
					// Second caveat for custom bootstrap select (generated) content
					// Also scroll to the parent element of the select instead
					else if($(element).parent('.bootstrap-select') && $(element).parent('.bootstrap-select').length > 0) {
						this.scrollToElement($(element).parent('.bootstrap-select')[0], -60);
					}
					else {
						this.scrollToElement(element, -60);
					}
				}
			},
			ignore: [],
			rules: {
				Salutation: {
					required: true
				},
				FirstName: {
					required: true
				},
				LastName: {
					required: true
				},
				Email: {
					required: true,
					email: true
				},
				Country: {
					required: true
				},
				Postcode: {
					required: true
				},
				EducationLevel: {
					required: true
				},
				OverMinimumAge: {
					required: true
				},
				Password: {
					required: true
				},
				ConfirmPassword: {
					required: true,
					equalTo: '[name="Password"]'
				},
				TermsAndConditions: {
					required: true
				}
			},
			messages: this.messages,
			errorClass: 'error-messages is-active mt-1',
			errorElement: 'span',
			errorPlacement: (error, element) => {
				if($(element).is('select')) {
					$(element).parents('.bootstrap-select').after(error);
				}
				else if($(element).attr('name') === 'Password' || $(element).attr('name') === 'ConfirmPassword') {
					if((!_.isNil($('[name="Password"]').val()) && $('[name="Password"]').val() !== '') &&
						(!_.isNil($('[name="ConfirmPassword"]').val()) && $('[name="ConfirmPassword"]').val() !== '') &&
						$('[name="Password"]').val() !== $('[name="ConfirmPassword"]').val()) {
						$('[name="ConfirmPassword"]').after(error);
					}
					else if($(element).attr('name') === 'Password') {
						$('[name="Password"]').after(error);
					}
					else if($(element).attr('name') === 'ConfirmPassword') {
						$('[name="ConfirmPassword"]').after(error);
					}
				}
				else if($(element).attr('name') === 'TermsAndConditions'
					|| $(element).attr('name') === 'OverMinimumAge'
					|| $(element).attr('name') === 'FacilitatorDocument') {
					$(element).parents('.custom-control').after(error);
				}
				else {
					error.insertAfter(element);
				}
			},
			highlight: (element) => {
				$(element).addClass('is-invalid').removeClass('is-valid');
			},
			unhighlight: (element) => {
				$(element).addClass('is-valid').removeClass('is-invalid');
			}
		});
	}
}
